import React, { Component } from "react";
import { Row, Col, Form, Tag, Typography, Empty, Button, Select } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {
    FormItem,
    InputItem,
    InputNumberItem,
    DatePickerItem,
    SelectItem,
    HeaderItem,
    BoxItem,
    ButtonItem,
} from "../Items";
import { CANALES_REQUERIMIENTO } from "./formatoRequerimientoExcel";

const { Text } = Typography;
const { Option } = Select;

const layoutCampo = { labelCol: { span: 9 }, wrapperCol: { span: 15 } };

const COLUMNAS_DESTINO = [
    { campo: "direccion", titulo: "Dirección", ancho: 380 },
    { campo: "contacto", titulo: "Contacto", ancho: 160 },
    { campo: "telefono", titulo: "Teléfono", ancho: 120 },
];

const estiloCeldaEncabezado = {
    padding: "4px 6px",
    background: "#fafafa",
    borderBottom: "1px solid #f0f0f0",
    fontWeight: 600,
    fontSize: 12,
    whiteSpace: "nowrap",
    textAlign: "left",
};
const estiloCelda = { padding: "2px 4px", borderBottom: "1px solid #f5f5f5", verticalAlign: "top" };

// Pestaña "Requerimiento" de Agregar Cotizacion (complemento
// formatoRequerimientoCotizaciones). Va con forceRender en la pagina: sus campos tienen
// que registrarse aunque el usuario nunca abra la pestaña, o onFinish no los recibe.
// La edicion y el destino por renglon (insumos[i].edicionRequerimiento y
// destinoRequerimiento) se editan aqui para no tocar FilaInsumosCotizacion, que se
// comparte con Editar.
class TabFormatoRequerimiento extends Component {
    descripcionInsumo = (insumoId) => {
        const id = insumoId?._id || insumoId;
        if (!id) return null;
        const insumo = (this.props.todasInsumos || []).find((i) => i._id?.toString() === id.toString());
        if (!insumo) return null;
        const codigo = insumo.codigoBarras || insumo.clave;
        return codigo ? `${codigo} - ${insumo.descripcion}` : insumo.descripcion;
    };

    renderDatos() {
        return (
            <>
                <HeaderItem>DATOS DEL CLIENTE</HeaderItem>
                <BoxItem>
                    <Row gutter={16}>
                        <Col xs={24} lg={12}>
                            <FormItem
                                name={["formatoRequerimiento", "clienteInstitucion"]}
                                label="Cliente / Institución"
                                max={200}
                                margin
                                {...layoutCampo}
                            >
                                <InputItem placeholder="Como lo escribió el cliente" />
                            </FormItem>
                            <FormItem
                                name={["formatoRequerimiento", "canal"]}
                                label="Canal"
                                margin
                                {...layoutCampo}
                            >
                                <SelectItem placeholder="Canal" allowClear>
                                    {CANALES_REQUERIMIENTO.map((canal) => (
                                        <Option key={canal} value={canal}>
                                            {canal}
                                        </Option>
                                    ))}
                                </SelectItem>
                            </FormItem>
                            <FormItem
                                name={["formatoRequerimiento", "contacto"]}
                                label="Contacto"
                                max={200}
                                margin
                                {...layoutCampo}
                            >
                                <InputItem placeholder="Contacto" />
                            </FormItem>
                        </Col>
                        <Col xs={24} lg={12}>
                            <FormItem
                                name={["formatoRequerimiento", "telefono"]}
                                label="Teléfono"
                                max={100}
                                margin
                                {...layoutCampo}
                            >
                                <InputItem placeholder="Teléfono" />
                            </FormItem>
                            <FormItem
                                name={["formatoRequerimiento", "correo"]}
                                label="Correo"
                                max={200}
                                margin
                                {...layoutCampo}
                            >
                                <InputItem placeholder="Correo" />
                            </FormItem>
                            <FormItem
                                name={["formatoRequerimiento", "fechaRequerimiento"]}
                                label="F. del requerimiento"
                                margin
                                {...layoutCampo}
                            >
                                <DatePickerItem placeholder="Fecha del requerimiento" />
                            </FormItem>
                            <FormItem
                                name={["formatoRequerimiento", "fechaEntregaRequerida"]}
                                label="F. requerida de entrega"
                                margin
                                {...layoutCampo}
                            >
                                <DatePickerItem placeholder="Fecha requerida de entrega" />
                            </FormItem>
                        </Col>
                    </Row>
                </BoxItem>
            </>
        );
    }

    renderDestinos() {
        return (
            <>
                <HeaderItem>DIRECCIONES DE ENTREGA</HeaderItem>
                <BoxItem>
                    <Form.List name={["formatoRequerimiento", "destinos"]}>
                        {(fields, { add, remove }) => (
                            <>
                                <div style={{ overflowX: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...estiloCeldaEncabezado, width: 70 }}>No.</th>
                                                {COLUMNAS_DESTINO.map((c) => (
                                                    <th key={c.campo} style={{ ...estiloCeldaEncabezado, minWidth: c.ancho }}>
                                                        {c.titulo}
                                                    </th>
                                                ))}
                                                <th style={{ ...estiloCeldaEncabezado, width: 40 }} />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fields.map((field) => (
                                                <tr key={field.key}>
                                                    <td style={estiloCelda}>
                                                        <FormItem noStyle name={[field.name, "numero"]}>
                                                            <InputNumberItem min={1} precision={0} style={{ width: "100%" }} />
                                                        </FormItem>
                                                    </td>
                                                    {COLUMNAS_DESTINO.map((c) => (
                                                        <td key={c.campo} style={estiloCelda}>
                                                            <FormItem noStyle name={[field.name, c.campo]}>
                                                                <InputItem />
                                                            </FormItem>
                                                        </td>
                                                    ))}
                                                    <td style={estiloCelda}>
                                                        <Button
                                                            type="link"
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => remove(field.name)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {fields.length === 0 && (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin direcciones de entrega" />
                                )}
                                <FormItem noStyle shouldUpdate>
                                    {({ getFieldValue }) => (
                                        <ButtonItem
                                            icon={<PlusOutlined />}
                                            style={{ marginTop: 8 }}
                                            onClick={() => {
                                                const numeros = (getFieldValue(["formatoRequerimiento", "destinos"]) || [])
                                                    .map((d) => Number(d?.numero))
                                                    .filter((n) => Number.isFinite(n));
                                                add({ numero: numeros.length > 0 ? Math.max(...numeros) + 1 : 1 });
                                            }}
                                        >
                                            Agregar destino
                                        </ButtonItem>
                                    )}
                                </FormItem>
                            </>
                        )}
                    </Form.List>
                </BoxItem>
            </>
        );
    }

    renderDestinoPorRenglon() {
        return (
            <>
                <HeaderItem>EDICIÓN Y DESTINO POR RENGLÓN</HeaderItem>
                <BoxItem>
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue, setFields }) => {
                            // Sin FormItem con name a proposito: un campo ["insumos", i, ...]
                            // que quedara registrado tras borrar el renglon i haria que
                            // validateFields inventara un renglon vacio. El Form.List de
                            // insumos ya devuelve cada renglon completo.
                            const ponerEnRenglon = (index, campo, valor) =>
                                setFields([{ name: ["insumos", index, campo], value: valor }]);
                            const insumos = getFieldValue("insumos") || [];
                            const numerosDestino = new Set(
                                (getFieldValue(["formatoRequerimiento", "destinos"]) || [])
                                    .map((d) => Number(d?.numero))
                                    .filter((n) => Number.isFinite(n))
                            );
                            if (insumos.length === 0) {
                                return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin renglones" />;
                            }
                            return (
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...estiloCeldaEncabezado, width: 40 }}>#</th>
                                            <th style={estiloCeldaEncabezado}>Insumo</th>
                                            <th style={{ ...estiloCeldaEncabezado, width: 90 }}>Cantidad</th>
                                            <th style={{ ...estiloCeldaEncabezado, width: 110 }}>Edición</th>
                                            <th style={{ ...estiloCeldaEncabezado, width: 150 }}>No. de destino</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {insumos.map((renglon, index) => {
                                            const destino = renglon?.destinoRequerimiento;
                                            const destinoDesconocido =
                                                destino !== undefined &&
                                                destino !== null &&
                                                destino !== "" &&
                                                !numerosDestino.has(Number(destino));
                                            return (
                                                <tr key={index}>
                                                    <td style={estiloCelda}>{index + 1}</td>
                                                    <td style={estiloCelda}>
                                                        {this.descripcionInsumo(renglon?.insumoId) || (
                                                            <Text type="secondary">Sin insumo</Text>
                                                        )}
                                                    </td>
                                                    <td style={estiloCelda}>{renglon?.cantidad ?? "—"}</td>
                                                    <td style={estiloCelda}>
                                                        <InputItem
                                                            maxLength={50}
                                                            value={renglon?.edicionRequerimiento ?? ""}
                                                            onChange={(e) =>
                                                                ponerEnRenglon(index, "edicionRequerimiento", e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                    <td style={estiloCelda}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                            <InputNumberItem
                                                                min={1}
                                                                precision={0}
                                                                style={{ width: 70 }}
                                                                value={destino ?? null}
                                                                onChange={(valor) =>
                                                                    ponerEnRenglon(
                                                                        index,
                                                                        "destinoRequerimiento",
                                                                        valor === undefined ? null : valor
                                                                    )
                                                                }
                                                            />
                                                            {destinoDesconocido && <Tag color="gold">No existe</Tag>}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            );
                        }}
                    </FormItem>
                </BoxItem>
            </>
        );
    }

    render() {
        return (
            <div style={{ padding: "8px 0" }}>
                {this.renderDatos()}
                {this.renderDestinos()}
                {this.renderDestinoPorRenglon()}
            </div>
        );
    }
}

export default TabFormatoRequerimiento;
